// src/modules/app-views/dataSearch/pages/Search/components/WelcomeScreen.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex } from 'antd';
import { SearchOutlined, HistoryOutlined } from '@ant-design/icons';
import SimpleButton from 'components/SimpleComponents/SimpleButton';
import translateX from 'utils/translateX';
import SearchHeader from './SearchHeader';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
/**
 * WelcomeScreen - Welcome screen for data search with start and history buttons
 */
const WelcomeScreen = ({ isMobile, onStartSearch, onGoBack }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <SearchHeader isMobile={isMobile} showDescription>
      <Flex gap={12} vertical={isMobile} justify="center" align="center" className="mt-5">
        <SimpleButton
          type="primary"
          title={translateX('start_search')}
          icon={<SearchOutlined />}
          onClick={onStartSearch}
          style={{ width: 160 }}
        />
        <SimpleButton
          type="default"
          title={translateX('view_history')}
          icon={<HistoryOutlined />}
          onClick={onGoBack}
          style={{ width: 160 }}
        />
      </Flex>
    </SearchHeader>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default WelcomeScreen;
